import React from 'react';
import { ReactComponent as F1Blueprint } from '../assets/f1-blueprint.svg';

// Fixed chalkboard backdrop: texture + drafting grid + double-line drawing frame. Purely decorative (pointer-events: none).
// The F1 drawing is generated by scripts/generate_f1_blueprint.py.
export default function BlueprintBackground({ showCar = true }) {
    return (
        <div className="bp-root" aria-hidden="true">
            <div className="bp-board" />
            <div className="bp-grid" />
            <div className="bp-drawings">
                {showCar && <F1Blueprint className="bp-f1" />}
            </div>
            <div className="bp-frame" />
        </div>
    );
}
